<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} <a id="pixinventLink"
      href="https://planticco.com/">PlanTICco </a>
    <span class="d-none d-sm-inline-block">Todos los derechos reservados</span>
  </p>
</footer>
<!--Footer Ends-->
